<template>
    <div>
      <CRow>
        <CCol sm="12" md="12">
          <CCard accent-color="primary">
            <CCardHeader
              class="font-weight-bold padding-sm d-flex justify-content-between catalogo-text"
            >
              Historial de bonos aplicados

            </CCardHeader>
            <CCardBody>
              <CRow>
                <CCol md="6" lg="6" xl="4">
                  <label class="d-block">Periodo:</label>
                  <DateSelector
                    class="z-custom-2 mb-2"
                    v-model="selectedDate"
                    :date="selectedDate"
                    @input="dateSelection()"
                  />
                </CCol>
              </CRow>

              <CDataTable
                hover
                bordered
                small
                fixed
                :loading="isLoading"
                :items="this.items"
                :fields="headersTable"
                :items-per-page="Number(limit)"
                :noItemsView="noItems"
              >
                <template #over-table>
                  <CRow class="">
                    <CCol v-if="advanceFilter" sm="11" col="10">
                      <CRow class="advance-filter mb-4">
                        <CCol md="6" class="py-1">
                          <label class="d-block">Trabajador:</label>
                          <div class="d-flex margin-multi align-items-center">
                            <MultiSelectC
                              v-model="query.trabajadores"
                              :options="trabajadores"
                              :multiple="true"
                              :loading="isLoadingInfo"
                              label="label"
                              track-by="label"
                              placeholder="Trabajadores"
                              :close-on-select="false"
                              :clear-on-select="false"

                            >
                              <template #no-options>Sin resultados.</template>
                            </MultiSelectC>
                            <transition name="fade">
                              <div v-show="query.trabajadores && query.trabajadores.length" @click="()=>{query.trabajadores = []}">
                                <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                              </div>
                            </transition>
                          </div>
                        </CCol>
                        <CCol md="6" class="py-1" v-if="false && showUbicaciones">
                          <label class="d-block">Ubicaciones:</label>
                          <div class="d-flex margin-multi align-items-center">
                            <MultiSelectC
                              v-model="query.ubicaciones"
                              :options="ubicaciones.map(ubicacion => ({ value: ubicacion.id, label: ubicacion.payload.nombre })).sort((a,b)=>a.label.localeCompare(b.label))"
                              :multiple="true"
                              :loading="isLoadingInfo"
                              label="label"
                              track-by="label"
                              placeholder="Ubicaciones"
                              :close-on-select="false"
                              :clear-on-select="false"

                            >
                              <template #no-options>Sin resultados.</template>
                            </MultiSelectC>
                            <transition name="fade">
                              <div v-show="query.ubicaciones && query.ubicaciones.length" @click="()=>{query.ubicaciones = []}">
                                <CIcon size="lg" class="ml-2 cursor-p" name="cil-trash" />
                              </div>
                            </transition>
                          </div>
                        </CCol>

                        <CCol md="3" class="py-1">
                          <label class="d-block">Fecha inicial:</label>

                            <DateSelector
                              class="z-custom-2"
                              v-model="query.fecha_inicial"
                              :date="query.fecha_inicial"
                            />



                        </CCol>
                        <CCol md="3" class="py-1">
                          <label class="d-block">Fecha final:</label>

                            <DateSelector
                              class="z-custom-2"
                              v-model="query.fecha_final"
                              :date="query.fecha_final"
                            />


                        </CCol>
                        <CCol md="6" class="py-1">
                          <label class="d-block">Concepto:</label>
                          <CInput v-model="query.concepto" placeholder="Concepto" class="mb-0 align-self-center" />
                        </CCol>

                        <CCol sm="6" class="py-1">
                          <label>Tipo de costo:</label>
                          <vSelectC
                            :options="tiposCosto"
                            :loading="isLoadingInfo"
                            class="margin-multi"
                            placeholder="Selecciona un tipo de costo"
                            v-model="query.tipo_costo"
                          >
                            <template #open-indicator="{ attributes }">
                              <CIcon
                                v-bind="attributes"
                                class="cursor-p"
                                name="cil-caret-bottom"
                              />
                            </template>
                            <template #no-options>
                              Sin resultados.
                            </template>
                          </vSelectC>
                        </CCol>

                        <CCol md="6" class="py-1">
                          <label class="d-block">Monto:</label>
                          <CRow>
                            <CCol><CInput type="number" :value.sync="$v.query.monto.start.$model" placeholder="De" class="mb-0 align-self-center" :isValid="query_monto_start" /></CCol>
                            <CCol><CInput type="number" :value.sync="$v.query.monto.end.$model" placeholder="Al" class="mb-0 align-self-center"  :isValid="query_monto_end" /></CCol>
                          </CRow>
                        </CCol>

                        <CCol md="6" class="py-1">
                          <label class="d-block">Comentarios:</label>
                          <CInput v-model="query.comentarios" placeholder="Comentarios" class="mb-0 align-self-center" />
                        </CCol>
                        <CCol col="10" class="pt-3">
                          <CButton @click="validForm" color="primary"> Buscar</CButton>
                        </CCol>
                      </CRow>
                    </CCol>
                    <CCol v-else sm="11" col="10">
                      <CInput v-model="filter" @input="searchTimeOut()" placeholder="Búsqueda..." />
                    </CCol>
                    <CCol class="p-0" sm="1" col="2">
                      <CDropdown
                        placement="bottom-start"
                        add-menu-classes="pt-0"
                        color="primary"
                        :show.sync="dropdownCustom"
                      >
                        <template #toggler>
                          <CButton color="secondary">
                            <CIcon name="cil-settings" />
                          </CButton>
                        </template>

                        <template #default>
                          <div class="p-3 d-flex flex-column w-100">
                            <div class="mb-1">
                              <span>
                                <strong>Ver</strong>
                              </span>
                            </div>
                            <hr class="line mt-1 mb-3" />
                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <label class="mr-2">Busqueda avanzada:</label>
                              <CSwitch :checked="advanceFilter" @update:checked="toggleAdvanceFilter()" class="mx-1" color="primary" variant="3d" />
                            </div>

                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <label class="mr-2">Hora:</label>
                              <CSwitch
                                @update:checked="toggleHora()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <label class="mr-2">Fecha de creación:</label>
                              <CSwitch
                                @update:checked="toggleCreatedAt()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <label class="mr-2">Ubicaciones:</label>
                              <CSwitch
                                @update:checked="toggleUbicaciones()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <label class="mr-2">Autor:</label>
                              <CSwitch @update:checked="toggleMostrarAutor()" class="mx-1" color="primary" variant="3d" />
                            </div>

                            <div class="d-flex align-items-center justify-content-between mb-2">
                              <label class="mr-2">Cancelados:</label>
                              <CSwitch
                                @update:checked="toggleShowCancel()"
                                class="mx-1"
                                color="primary"
                                variant="3d"
                              />
                            </div>

                          </div>
                        </template>
                      </CDropdown>
                    </CCol>

                  </CRow>
                </template>

                <template #check-header>
                  <div class="d-flex flex-row" v-if="items.length">
                    <input id="all" type="checkbox" @input="checkAll" :checked="_laboresCheck_" class="ml-3" />
                  </div>
                </template>
                <template #check="{item}">
                  <td class="py-2"><input v-model="laboresCheck[item.folio]" type="checkbox" class="form-check-input ml-3" /></td>
                </template>

                <template #folio-header>
                  <div class="d-flex flex-row">
                    <span class="align-self-center">Folio</span>
                    <OrderButtons :onClick="sortField" :field="'doc_bonos_aplicados.folio'" :order="false" :fila="actualSort" :direcction="sorting"/>
                  </div>
                </template>
                <template #fechahora-header>
                  <div class="d-flex flex-row align-items-center">
                    <span class="align-self-center">Fecha</span>
                    <OrderButtons :onClick="sortField" :field="'doc_bonos_aplicados.payload->encabezado->fechahora'" :order="false" :fila="actualSort" :direcction="sorting"/>
                  </div>
                </template>
                <template #trabajador_id-header>
                  <div class="d-flex flex-row">
                    <span class="align-self-center">Trabajador</span>
                    <OrderButtons :onClick="sortField" :field="'trabajador.payload->nombre'" :order="true" :fila="actualSortJoin" :direcction="sortingJoin"/>
                  </div>
                </template>
                <template #fecha_inicial-header>
                  <div class="d-flex flex-row align-items-center">
                    <span class="align-self-center">Fecha inicio</span>
                    <OrderButtons :onClick="sortField" :field="'payload->encabezado->fecha_inicial'" :order="false" :fila="actualSort" :direcction="sorting"/>
                  </div>
                </template>
                <template #fecha_final-header>
                  <div class="d-flex flex-row align-items-center">
                    <span class="align-self-center">Fecha final</span>
                    <OrderButtons :onClick="sortField" :field="'payload->encabezado->fecha_final'" :order="false" :fila="actualSort" :direcction="sorting"/>
                  </div>
                </template>
                <template #concepto-header>
                  <div class="d-flex flex-row align-items-center">
                    <span class="align-self-center">Concepto</span>
                    <OrderButtons :onClick="sortField" :field="'payload->encabezado->concepto'" :order="false" :fila="actualSort" :direcction="sorting"/>
                  </div>
                </template>
                <template #folio="{item}">
                  <td class="py-2">{{ item.folio }}</td>
                </template>
                <template #fechahora="{item}">
                  <td class="py-2">{{ getDate(item.payload.encabezado.fechahora) }}</td>
                </template>
                <template #trabajador_id="{item}">
                  <td class="py-2">{{ item.payload.encabezado._relaciones.trabajador.payload.nombre }}</td>
                  <!-- <td class="py-2">{{ getTrabajador(item.payload.encabezado.trabajador_id) }}</td> -->
                </template>
                <template #fecha_inicial="{item}">
                  <td class="py-2">{{ getDate(item.payload.encabezado.fecha_inicial) }}</td>
                </template>
                <template #fecha_final="{item}">
                  <td class="py-2">{{ getDate(item.payload.encabezado.fecha_final) }}</td>
                </template>
                <template #ubicaciones-header>
                  <div class="d-flex flex-row">
                    <span v-show="showUbicaciones">Ubicaciones</span>
                  </div>
                </template>
                <template #ubicaciones="{item}">
                  <td class="py-2">
                    <span v-show="showUbicaciones">{{ getUbicaciones(item.payload.encabezado.ubicaciones) }}</span>
                  </td>
                </template>
                <template #concepto="{item}">
                  <td class="py-2">{{ item.payload.encabezado.concepto }}</td>
                </template>
                <template #monto="{item}">
                  <td class="py-2 text-right">
                    ${{ item.payload.encabezado.monto.toFixed(2).replace(
                    /\B(?=(\d{3})+(?!\d))/g,
                    ","
                    ) }}
                  </td>
                </template>
                <template #autor-header>
                  <div class="d-flex flex-row">
                    <span v-show="mostrarColumnaAutor">Autor</span>
                  </div>
                </template>
                <template #autor="{item}">
                  <td class="py-2">
                    <span v-show="mostrarColumnaAutor">{{ item.author.correo }}</span>
                  </td>
                </template>
                <template #hour-header>
                  <div class="d-flex flex-row">
                    <span v-show="showHora">Hora</span>
                  </div>
                </template>
                <template #hour="{item}">
                  <td class="py-2">
                    <span v-show="showHora">{{ getHour(item.payload.encabezado.fechahora) }}</span>
                  </td>
                </template>
                <template #created_at-header>
                  <div class="d-flex flex-row">
                    <span v-show="showCratedAt">Fecha de creación</span>
                  </div>
                </template>
                <template #created_at="{item}">
                  <td class="py-2">
                    <span v-show="showCratedAt">{{ getFullDate(item.created_at) }}</span>
                  </td>
                </template>
                <template #ver="{item}">
                  <td class="py-2">
                    <router-link
                      :to="{
                        name: 'VerBonoAplicado',
                        params: {
                          id: item.folio,
                          config: { page: page, dates: selectedDate }
                        }
                      }"
                    >
                      <CButton color="success" square size="sm">Ver</CButton>
                    </router-link>
                  </td>
                </template>
                <template #reporte="{item, index}">
                  <td class="py-2">
                    <CButton
                      color="info"
                      square
                      size="sm"
                      @click="getReporte(index, item)"
                    >
                    <i v-if="loader[index]" class="fa fa-spinner fa-pulse"></i>
                    <template v-else>PDF</template>
                    </CButton>
                  </td>
                </template>
                <template #under-table>
                  <div class="footer-table">
                    <div style="gap: 5px" class="d-flex align-items-center justify-content-start">
                      Total {{total}} ,
                      <CSelect
                      :value="limit"
                      label=""
                      invalidFeedback="Campo requerido, debe seleccionar una opción"
                      :options="[10,25,50,100]"
                      @update:value="v=>limit=v"
                      class="mb-0"
                      />{{" "}}artículos / página
                    </div>
                    <CPagination :activePage.sync="page" :pages="pages" align="center"
                      @update:activePage="e => actualizarInfo()" />
                  </div>
                </template>
              </CDataTable>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>



      <CModal
        size="sm"
        title="Reporte"
        :centered="true"
        color="warning"
        :show.sync="warningModal"
      >{{ error }}</CModal>
      <CModal
       :closeOnBackdrop="false"
        size="sm"
        :title="loadingModal||''"
        :centered="true"
        color="info"
        :show.sync="_loadingModal"
      >
        <template #footer>
          <strong></strong>
        </template>
        <div
          class="w-100 d-flex justify-content-center"
        >
          <div class="sk-flow align-items-center">
            <div class="sk-flow-dot bg-primary"></div>
            <div class="sk-flow-dot bg-primary"></div>
            <div class="sk-flow-dot bg-primary"></div>
          </div>
        </div>
      </CModal>
    </div>
  </template>

  <script>
  import moment from "moment";
  import DateSelector from "../../../customComponents/DateSelector";
  import OrderButtons from "../../../customComponents/OrderButtons";
  import GridAutorMixin from "../../../mixins/GridAutor";

  import vSelect from "vue-select";
  import { validationMixin } from "vuelidate";
  import "vue-select/dist/vue-select.css";

  const fields = [
    // { key: "check", label: "", _style: "width: 40px" },
    { key: "folio", label: "Folio", _style: "width: 70px" },
    { key: "fechahora", label: "Fecha", _style: "min-width: 70px" },
    { key: "hour", label: "Hora", _style: "", },
    { key: "trabajador_id", label: "Trabajador", _style: "" },
    { key: "ubicaciones", label: "Ubicaciones", _style: "", },
    { key: "concepto", label: "Concepto", _style: "" },
    { key: "monto", label: "Monto", _style: "width: 70px" },
    { key: "created_at", label: "Fecha de creación", _style: "" },
    {
      key: "autor",
      label: "",
      _style: "",
    },
      {
        key: "ver",
        label: "",
        _style: "width: 40px",
        sorter: false,
        filter: false
      },
      {
        key: "reporte",
        label: "",
        _style: "width: 40px",
        sorter: false,
        filter: false
      },
  ];



  export default {
    name: "BonoAplicado",

    components: {
      // "v-date-picker": DatePicker,
      DateSelector,
      OrderButtons,

      vSelectC: vSelect,
    },
    mixins: [GridAutorMixin,validationMixin],
    validations: {
      query:{
        monto:{
          start:{
            maxValue: (v,monto)=>{
              return monto.start && monto.end ? Number(v) <= Number(monto.end) : true
            }
          },
          end:{
            minValue: (v,monto)=>{
              return monto.start && monto.end ? Number(v) >= Number(monto.start) : true
            }
          }
        }
      }
    },
    data() {
      return {
        limit: 10,
        total: 0,
        laboresCheck: {},
        items: [],
        fields,
        labores: [],
        loadingModal: '',
        query:{
          fecha_inicial: {
            start: moment().startOf('Y'),
            end: moment().endOf('Y')
          },
          fecha_final: {
            start: moment().startOf('Y'),
            end: moment().endOf('Y')
          },
          monto:{start:'',end:''},
        },
        config: this.$route.params.config,
        dropdownCustom: false,
        show: false,
        showCancel: false, //toggleShowCancel
        isLoteActive: true,
        isCreated: false,
        color1: "primary",
        color2: "secondary",
        filter: "",
        noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
        ubicaciones: [],
        tiposCosto:[{ value: 'cosecha', label: 'Cosecha' },{ value: 'no_cosecha', label: 'No cosecha' }],
        actualSort: "doc_bonos_aplicados.payload->encabezado->fechahora",
        actualSortJoin: "",
        trabajadores: [],
        actividades: [],
        showUbicaciones: false,
        showHora: false,
        showCratedAt: false,
        advanceFilter: false,
        itemModal: { id: "", name: "", index: "" },
        isLoading: false,
        isLoadingInfo: false,
        page: 1,
        pages: 1,
        warningModal: false,
        error: "",
        sorting: "desc",
        sortingJoin: "",
        sort: [
          {
            field: "folio",
            isSorter: true
          },
          {
            field: "doc_bonos_aplicados.payload->encabezado->fechahora",
            isSorter: true
          }
        ],
        selectedDate: {
          start: moment()
            .startOf("month")
            .toDate(),

          end: moment()
            .endOf("month")
            .toDate()
        },
        loader:{},
      };
    },

    created() {
      if (this.ubicacionRaiz == "") {
        this.items = []
        return
      }
      this.isCreated = false;
      this.page = this.config ? this.config.page : 1;
      // console.log(this.page);
      this.selectedDate = this.config ? this.config.dates : this.selectedDate;
      this.actualizarInfo(true);
    },

    computed: {
      query_filter(){
        return Object.keys(this.query).reduce((v,key)=>{
          if(key==='trabajadores'){
            const trabajadoresIds = this.query.trabajadores.map(m=>m.value)
            trabajadoresIds.length&&
              v.push({
                field: "doc_bonos_aplicados.payload->encabezado->trabajador_id",
                operator: "regexp",
                value: `[[:<:]](${trabajadoresIds.join('|')})[[:>:]]`
              })
          }
          if(key==='fecha_inicial'){
            this.query.fecha_inicial&&v.push({
              field: "doc_bonos_aplicados.payload->encabezado->fecha_inicial",
              operator: ">=",
              value: moment(this.query.fecha_inicial.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_bonos_aplicados.payload->encabezado->fecha_inicial",
              operator: "<=",
              value: moment(this.query.fecha_inicial.end).format("YYYY-MM-DD 23:59:59")
            })
          }
          if(key==='fecha_final'){
            this.query.fecha_final&&v.push({
              field: "doc_bonos_aplicados.payload->encabezado->fecha_final",
              operator: ">=",
              value: moment(this.query.fecha_final.start).format("YYYY-MM-DD 00:00:00")
            },
            {
              field: "doc_bonos_aplicados.payload->encabezado->fecha_final",
              operator: "<=",
              value: moment(this.query.fecha_final.end).format("YYYY-MM-DD 23:59:59")
            })
          }
          if(key==='ubicaciones'){
            const ubicacionesIds = this.query.ubicaciones.map(m=>m.value)
            this.showUbicaciones&&ubicacionesIds.length&&
              v.push({
                field: "doc_bonos_aplicados.payload->encabezado->ubicaciones",
                operator: "regexp",
                value: `[[:<:]](${ubicacionesIds.join('|')})[[:>:]]`
              })
          }
          if(key==='tipo_costo'){
            this.query.tipo_costo&&
            v.push({
              field: "doc_bonos_aplicados.payload->encabezado->tipo_costo",
              operator: "=",
              value: `${this.query.tipo_costo.value}`
            })
          }
          if(key==='comentarios'){
            this.query.comentarios&&
            v.push({
              field: "doc_bonos_aplicados.payload->encabezado->comentarios",
              operator: "like",
              value: `%${this.query.comentarios}%`,
              collate: "utf8mb4_unicode_ci"
            })
          }
          if(key==='concepto'){
            this.query.concepto&&
            v.push({
              field: "doc_bonos_aplicados.payload->encabezado->concepto",
              operator: "like",
              value: `%${this.query.concepto}%`,
              collate: "utf8mb4_unicode_ci"
            })
          }
          if(key==='monto'){
            this.query.monto.start&&
            v.push({
              field: "doc_bonos_aplicados.payload->encabezado->monto",
              operator: ">=",
              value: Number(this.query.monto.start),
            })
            this.query.monto.end&&
            v.push({
              field: "doc_bonos_aplicados.payload->encabezado->monto",
              operator: "<=",
              value: Number(this.query.monto.end),
            })
          }
          return v
        },[])
      },
      query_monto_start(){
        return this.$v.query.monto.start.$dirty?!this.$v.query.monto.start.$invalid:null
      },
      query_monto_end(){
        return this.$v.query.monto.end.$dirty?!this.$v.query.monto.end.$invalid:null
      },
      _loadingModal:{
        get(){
          return !!this.loadingModal
        },
        set(val){
          this.loadingModal = val||''
        }
      },
      _countSelected_(){
        return Object.keys(this.laboresCheck).reduce((v,key)=>this.laboresCheck[key]?v+1:v,0)
      },
      _laboresCheck_(){
        return Object.keys(this.laboresCheck).length&&this.items.map(m=>m.folio).every(key=>this.laboresCheck[key])
      },
      laboresIsSelected(){
        return Object.keys(this.laboresCheck).some(s=>this.laboresCheck[s])
      },
      laboresCheck_(){
        return Object.keys(this.laboresCheck).filter(ff=>this.laboresCheck[ff])
      },
      rangeStart() {
        return new Date(this.selectedDate.start).toLocaleDateString();
      },
      rangeEnd() {
        return new Date(this.selectedDate.end).toLocaleDateString();
      },
      filteredItems() {
        return this.items.filter(
          i =>
            i.folio
              .toString()
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            this.getDate(i.payload.encabezado.fechahora)
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            this.getTrabajador(i.payload.encabezado.trabajador_id)
              .toLowerCase()
              .includes(this.filter.toLowerCase()) ||
            this.getActividades(i.payload.encabezado.actividad_id)
              .toLowerCase()
              .includes(this.filter.toLowerCase())
        );
      },
      headersTable() {
        return this.fields.filter(ff=>{
          if(
            (ff.key==='ubicaciones'&&!this.showUbicaciones) ||
            (ff.key==='hour'&&!this.showHora) ||
            (ff.key==='created_at'&&!this.showCratedAt) ||
            (ff.key==='autor'&&!this.mostrarColumnaAutor)
          ){
            return false
          }
          return true
        })
      },
      ubicacionRaiz() {
        return this.$store.state.rootLocation
          ? this.$store.state.rootLocation.value
          : "";
      },
      ubicacionRaizValue() {
        return this.$store.state.rootLocation
          ? this.$store.state.rootLocation.value
          : "";
      }
    },

    watch: {
      limit() {
        this.actualizarInfo()
      },
      items(newV,){
        this.loader = newV.reduce((v,c,i)=>({...v,[i]:false}),{})
        Object.keys(this.laboresCheck).forEach(key=>{
          if (!newV.find(f=>f.folio === Number(key))) {
            delete this.laboresCheck[key];
          }
        })
      },
      ubicacionRaiz: function() {
        if (this.ubicacionRaiz == "") {
          this.items = []
          return
        }
        this.page = 1;
        this.actualizarInfo(true);
      }
    },

    methods: {

      validForm(){
        this.$v.$reset();
        this.$v.$touch();
        if(!this.$v.$invalid){
          this.actualizarInfo()
        }
      },
      checkAll(e){
          this.laboresCheck = this.items.reduce((v,c)=>{
            v[c.folio] = e.target.checked
            return v
          },{})

      },
      getReporte(index,item){
        if(this.loader[index]){
          return
        }
        this.loader[index] = true
        this.$forceUpdate();
        const reportCall = {
          reporte: "formato_bonos_aplicados",
          params: { folio:item.folio, ubicaciones: [this.ubicacionRaiz]},
          pdf : true
        };

        // console.log(reportCall);
        // call.push(reportCall);


          this.$store.dispatch("reportsPDFHttp", {
            ...reportCall
          }).then(res => {

            const blob = res;

            let a = document.createElement("a");
            a.style = "display: none";
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = "Reporte de bonos aplicados.pdf";
            a.click();
            window.URL.revokeObjectURL(url);
          })
          .catch(rej => {
            // console.log(rej);
            this.error = rej.message;
            this.warningModal = true;
          })

          .finally(() => {
            this.loader[index] = false
            this.$forceUpdate();
          });
      },
      closeDropdown() {
        this.dropdownCustom = false;
      },
      searchTimeOut() {
        if (this.isCreated) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            // console.log("funciona");

            this.actualizarInfo();
          }, 800);
        }
      },
      toggleUbicaciones() {
        this.showUbicaciones = !this.showUbicaciones;
      },
      toggleHora() {
        this.showHora = !this.showHora;
      },
      toggleCreatedAt() {
        this.showCratedAt = !this.showCratedAt;
      },
      toggleShowCancel() {
        this.showCancel = !this.showCancel;
        this.actualizarInfo();
      },
      toggleAdvanceFilter() {
        this.advanceFilter = !this.advanceFilter;
      },
      sortField(field, direction, join) {
        if (join) {
          this.actualSort = ""
          this.sorting = ""
          this.actualSortJoin = field
          this.sortingJoin = direction
        }else{
          this.actualSort = field
          this.sorting = direction
          this.actualSortJoin = ""
          this.sortingJoin = ""
        }
        this.actualizarInfo();
      },
      getSorted(field) {
        const newSort = this.sort.find(item => item.field == field);
        if (newSort) {
          return newSort.isSorter;
        }
        return false;
      },
      getTrabajador(trabajador_id) {
        const trabajadorActual = this.trabajadores.filter(
          trabajador => trabajador.id == trabajador_id
        );
        if (trabajadorActual.length > 0) {
          return trabajadorActual[0].payload.nombre;
        } else {
          return "";
        }
      },
      dateSelection() {
        if(this.advanceFilter){
          return
        }
        if (this.isCreated) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          this.timer = setTimeout(() => {
            // console.log("funciona");
            this.actualizarInfo();
          }, 800);
        }
      },
      getFullDate(date) {
        if(date === undefined || date === '') {
          return 'N/A';
        }
        let newDate = moment(date);
        return newDate.format("DD/MM/YYYY HH:mm:ss");
      },
      getDate(date) {
        if(date === undefined || date === '') {
          return 'N/A';
        }
        let newDate = moment(date,"YYYY-MM-DD 00:00:00");
        return newDate.format("DD/MM/YYYY");
      },
      getHour(date) {
        if(date === undefined || date === '') {
          return 'N/A';
        }
        let newDate = moment(date);
        return newDate.format("HH:mm:ss");
      },
      toggleEdit(index, item) {
        this.modal = true;
        const itemIndex = {
          id: index,
          name: item.cultivo
        };
        this.itemModal = itemIndex;
      },
      filterLotes() {
        // let compareLote = this.lotes.find(lote => lote.value == this.lote);
        return this.items.filter(
          doc =>
            new Date(doc.payload.encabezado.fechahora) >=
              this.selectedDate.start &&
            new Date(doc.payload.encabezado.fechahora) <= this.selectedDate.end
        );
      },
      getUbicaciones(ubicaciones) {
        let nombreUbicaciones = "";
        let ubicacionActual;
        ubicaciones.forEach(element => {
          ubicacionActual = this.ubicaciones.find(
            ubicacion => ubicacion.id == element
          );
          console.log(ubicacionActual,this.ubicaciones);

          if (ubicacionActual) {
            nombreUbicaciones = `${nombreUbicaciones}${ubicacionActual.payload.nombre}, `;
          }
        });
        let nombreUbicacionesLast = nombreUbicaciones.slice(0, -2);
        return nombreUbicacionesLast;
      },
      actualizarInfo(flagCombos = false) {
        this.$v.$reset();
        const ubicacionesIds = this.filter?this.ubicaciones.filter(ff=>ff.payload.nombre.toUpperCase().includes(this.filter.toUpperCase())).map(m=>m.id):[]

        this.isLoading = true;
        let template = {
          schema: "bonos_aplicados",
          limit: this.limit,
          page: this.page,
          filter: {
            wherein: [
              {
                field: "doc_bonos_aplicados.payload->encabezado->ubicacion_raiz_id",
                value: [this.ubicacionRaiz]
              }
            ],
            where: [
              {
                field: "doc_bonos_aplicados.payload->encabezado->fechahora",
                operator: ">=",
                value: moment(this.selectedDate.start).format(
                  "YYYY-MM-DD 00:00:00"
                )
              },
              {
                field: "doc_bonos_aplicados.payload->encabezado->fechahora",
                operator: "<=",
                value: moment(this.selectedDate.end).format("YYYY-MM-DD 23:59:59")
              }
            ]
          },
          ["with-storage"]: ["*"]
        };

        this.actualSort != "" ? (template = {
          ...template,
          order: [{
            field: this.actualSort,
            direction: this.sorting
          }]
        }) : null

        this.actualSortJoin != "" ? (template = {
          ...template,
          orderByJoin: [{
            field: this.actualSortJoin,
            direction: this.sortingJoin
          }]
        }) : null

        !this.advanceFilter && this.filter != "" ? (template = {
          ...template, filter: {
            ...template.filter,
            and: {
              orwhere: [
                {
                  field: "doc_bonos_aplicados.folio",
                  operator: "like",
                  value: `%${this.filter}%`,
                  collate: "utf8mb4_unicode_ci"
                },
                {
                  field: "doc_bonos_aplicados.payload->encabezado->concepto",
                  operator: "like",
                  value: `%${this.filter}%`,
                  collate: "utf8mb4_unicode_ci"
                },
                {
                  field: "doc_bonos_aplicados.payload->encabezado->monto",
                  operator: "like",
                  value: `%${this.filter}%`,
                  collate: "utf8mb4_unicode_ci"
                },
                ...this.showUbicaciones&&ubicacionesIds.length?[
                {
                  field: "doc_bonos_aplicados.payload->encabezado->ubicaciones",
                  operator: "regexp",
                  value: `[[:<:]](${ubicacionesIds.join('|')})[[:>:]]`
                },
                ]:[],
                ...this.mostrarColumnaAutor?[
                {
                  field: "doc_bonos_aplicados.author->correo",
                  operator: "like",
                  value: `%${this.filter}%`,
                  collate: "utf8mb4_unicode_ci"
                },
                ]:[]
              ],
              orWhereJoin: [
                {
                  field: "trabajador.payload->nombre",
                  operator: "like",
                  value: `%${this.filter}%`,
                  collate: "utf8mb4_unicode_ci"
                }
              ]
            }
          }
        }) : null;

        if(this.advanceFilter&&(this.query_filter.length>0)){
          template.filter.and = {
            ...this.query_filter.length?{where: this.query_filter}:{}
          }
        }

        !this.showCancel
          ? (template = {
              ...template,
              filter: {
                ...template.filter,
                where: [
                  ...template.filter.where,
                  {
                    field: "doc_bonos_aplicados.estado",
                    operator: "!=",
                    value: "cancelado"
                  }
                ]
              }
            })
          : null;

        const documento = [
          this.$store.dispatch("customDocumentoHTTP", template)
        ]
        if(flagCombos){
          this.isLoadingInfo = true
          documento.push(
            this.$store.dispatch("customHTTP", {
              schema: "ubicaciones",
              filter: {
                where: [
                  {
                    field: "payload->suspendido",
                    value: false,
                    operator: "="
                  }
                ]
              },
              order:[{
                field: 'payload->nombre',
                direction: 'asc'
              }]
            }),
            this.$store.dispatch("customHTTP", {
              schema: "trabajadores",
                filter: {
                  where: [
                    {
                      field: "payload->ubicaciones",
                      operator: "regexp",
                      value: `[[:<:]]${this.ubicacionRaiz}[[:>:]]`
                    },
                    {
                      field: "payload->suspendido",
                      operator: "=",
                      value: false
                    }
                  ],
                }
            })
          );
        }
        Promise.all(documento)
          .then(([documentos, ubicaciones, trabajadores]) => {

            this.total = documentos?.paginate?.total||0
            this.items = documentos.data;
            this.pages = documentos?.paginate?.last_page;
            this.page = documentos?.paginate?.current_page;
            if(ubicaciones&&ubicaciones.data.length>0){
              this.ubicaciones = ubicaciones.data
            }
            if(trabajadores&&trabajadores.data.length>0){
              this.trabajadores = trabajadores.data.map(trabajador => {
                return {
                  value: trabajador.id,
                  label: trabajador.payload.nombre
                };
              }).sort((a,b)=>a.label.localeCompare(b.label));
            }
            this.isCreated = true;
          })
          .catch(rej => console.log(rej.message))
          .finally(() => {
            this.isLoading = false
            this.isLoadingInfo = false
          });
      }
    }
  };
  </script>

  <style src="spinkit/spinkit.min.css"></style>
  <style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

  <style>

  .footer-table{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .dropdown-menu{
    min-width: 14rem;
  }
  .advance-filter .multiselect__spinner{
    height: 30px;
  }
  .advance-filter .multiselect__placeholder{
    margin-bottom: 0px;
  }
  .advance-filter .multiselect__select{
    height: 34px;
  }
  .advance-filter .multiselect__tags{
      max-height: 35px;
      overflow: auto;
      min-height: unset;
      padding: 5px 40px 5px 5px;
  }
  .advance-filter .multiselect__content-wrapper{
      width: 100%;
  }
  .advance-filter .vs__dropdown-toggle{
      height: 35px;
  }
  </style>
  <style scoped>
  .line {
    width: 100%;
    color: #321fdb; /* old IE */
    background-color: #321fdb; /* Modern Browsers */
  }
  .z-custom {
    z-index: 1;
  }
  .z-custom-2 {
    z-index: 4;
  }
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }
  .catalogo-text {
    font-size: 1.2rem !important;
  }

  .custom-width-btn {
    width: 40%;
  }
  .custom-heigth-btn {
    width: 100%;
  }
  .custom-font-size {
    font-size: 1rem;
  }
  @media (max-width: 420px) {
    .btn-header {
      padding-left: 6px;
      padding-right: 6px;
      font-size: 11px;
    }
    .padding-sm {
      padding-left: 10px;
      padding-right: 10px;
    }
    .text-sm {
      font-size: 11px !important;
    }
    .margin-sm {
      margin: 5px;
    }
  }
  </style>
